import { IScheduleService } from "../../models/schedule/IScheduleService";
import { IScheduleOptions } from "../app.config.service";
import { GenesysAppointmentService } from "./genesys.appointment.service";
import { GenesysCallbackService } from "./genesys.callback.service";
import { TalkdeskAppointmentService } from "./talkdesk.appointment.service";

class ScheduleFactoryCtrl {
  private _instance: IScheduleService;

  public create<C extends IScheduleOptions>(config: C) {
    switch (config.scheduleMode) {
      case "genesys-callback":
        this._instance = new GenesysCallbackService(config);
        break;
      case "genesys-appointment":
        this._instance = new GenesysAppointmentService();
        break;
        case "talkdesk-appointment":
      this._instance = new TalkdeskAppointmentService();
        break;
    }
  }

  public get instance(): IScheduleService {
    if (!this._instance) {
      throw new Error("schedule service not initialised");
    }
    return this._instance;
  }
}

export const ScheduleFactory = new ScheduleFactoryCtrl();
